export const typesReembolsos = {

  storeReembolsos:    '[reembolsos] storeReembolsos',
  setLoading:         '[reembolsos] setLoading',
  
};